import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FiArrowRight, FiX } from 'react-icons/fi';
import AppTextInput from '../../../../shared/components/app-text-input/AppTextInput';
import { bookingDetailsRoute } from '../../constants/packageConstants';
import { PACKAGE_REF_RE } from '../../utils/packageUtils';
import '../../styles/packagesShared.scss';

/**
 * Open a package booking by its booking ID (PKGB…). There is no "list my
 * package bookings" API yet, so this is how an agent gets back to one.
 */
function PackageBookingLookup({ show, onHide }) {
  const navigate = useNavigate();
  const [ref, setRef] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      setRef('');
      setError('');
    }
  }, [show]);

  const submit = (e) => {
    e.preventDefault();
    const value = ref.trim();
    if (!PACKAGE_REF_RE.test(value)) {
      setError('Enter the booking ID shown on the confirmation, e.g. PKGB…');
      return;
    }
    onHide();
    navigate(bookingDetailsRoute(value));
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="pkg-modal">
      <Modal.Body>
        <button
          type="button"
          className="pkg-modal__close"
          onClick={onHide}
          aria-label="Close"
        >
          <FiX />
        </button>
        <h3 className="pkg-modal__title">Find a package booking</h3>
        <p className="pkg-modal__sub">
          Enter the booking ID from the confirmation page.
        </p>
        <form onSubmit={submit} noValidate>
          <AppTextInput
            name="pkgBookingId"
            label="Booking ID"
            required
            value={ref}
            onChange={(e) => {
              setRef(e.target.value.replace(/[^A-Za-z0-9-]/g, '').slice(0, 40));
              setError('');
            }}
          />
          {error && <span className="pkg-field-error">{error}</span>}
          <div className="d-flex justify-content-end mt-3">
            <button type="submit" className="pkg-state__primary">
              View booking <FiArrowRight />
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

PackageBookingLookup.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default PackageBookingLookup;
